(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/joker/joker-price.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/joker/joker-price.js');

'use strict';

svs.numbergames.game.views.JokerPrice = Marionette.View.extend({
  className: 'numbergames-footer-section',
  regions: {
    jokerInfoRegion: '#jokerInfoRegion'
  },
  ui: {
    priceRadio: '.js-joker-price-radio',
    jokerInfo: '.js-joker-info'
  },
  triggers: {
    'change @ui.priceRadio': 'changeJokerPrice',
    'click @ui.jokerInfo': 'clickedJokerInfo'
  },
  modelEvents: {
    'change:isSubscription': 'render',
    'change:jokerPrice': 'onUpdateDOMSelection'
  },
  initialize() {
    var _svs$numbergames$game, _svs$numbergames$draw;
    const upcomingJoker = svs.numbergames.productMapping.getJokerProductId((_svs$numbergames$game = svs.numbergames.game.draw) === null || _svs$numbergames$game === void 0 ? void 0 : _svs$numbergames$game.upcomingDrawProduct);
    const {
      productId: product,
      drawNumber
    } = (_svs$numbergames$draw = svs.numbergames.draws.drawsApi.firstPlayableDraw('joker')[upcomingJoker]) !== null && _svs$numbergames$draw !== void 0 ? _svs$numbergames$draw : {};
    this.isNewJokerRules = svs.numbergames.rules.utils.joker.isNewRules({
      product,
      drawNumber
    });
  },
  template(data) {
    return svs.numbergames.game.templates.joker_price(data);
  },
  templateContext() {
    const jokerPrices = svs.numbergames.rules.joker.getJokerPrices();
    const viewOptions = svs.numbergames.game.view_options[this.model.get('productId')];
    return {
      jokerPrices: jokerPrices.map(price => ({
        price
      })),
      isJokerOpen: svs.numbergames.game.draw.isJokerOpen,
      showJokerInfo: Boolean(viewOptions.jokerInfoDialog)
    };
  },
  onRender() {
    this.showChildView('jokerInfoRegion', {
      model: this.model,
      modelEvents: {
        'change:hasJoker change:isSyndicate': 'render'
      },
      className: 'numbergames-footer-section-info-text',
      template(data) {
        var _svs$numbergames$game2;
        const jokerInfoTemplate = (_svs$numbergames$game2 = svs.numbergames.game.view_options[data.productId]) === null || _svs$numbergames$game2 === void 0 ? void 0 : _svs$numbergames$game2.jokerInfoTemplate;
        const jokerInfoText = jokerInfoTemplate && jokerInfoTemplate(data);
        if (jokerInfoText) {
          return "<p>".concat(jokerInfoText, "</p>");
        }
        return '';
      }
    });
  },
  onChangeJokerPrice(view, event) {
    this.model.set({
      jokerPrice: parseInt(event.target.value, 10)
    });
  },
  onUpdateDOMSelection() {
    this.getUI('priceRadio').each((i, el) => {
      el.checked = parseInt(el.value, 10) === this.model.get('jokerPrice');
    });
  },
  onClickedJokerInfo() {
    var _viewOptions$jokerInf;
    const viewOptions = svs.numbergames.game.view_options[this.model.get('productId')];
    viewOptions === null || viewOptions === void 0 || (_viewOptions$jokerInf = viewOptions.jokerInfoDialog) === null || _viewOptions$jokerInf === void 0 || _viewOptions$jokerInf.call(viewOptions, this.getUI('jokerInfo'), this.isNewJokerRules);
  }
});

 })(window);